import React from "react";
import styled from "styled-components";

const Add = ({ isOpen, onClose, isSidebarOpen }) => {
  if (!isOpen) return null; // ✅ Ensure the modal doesn't render if it's closed

  return (
    <ModalOverlay>
      <ModalContent isSidebarOpen={isSidebarOpen}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <ModalTitle>ADD PRODUCTS</ModalTitle>
        <Form>
          <FormRow>
            <FormGroup>
              <Label>Seller Name</Label>
              <Input type="text" placeholder="Enter full name" />
            </FormGroup>
            <FormGroup>
              <Label>Product Name</Label>
              <Input type="text" placeholder="Enter Product name" />
            </FormGroup>
          </FormRow>

          <FormRow>
            <FormGroup>
              <Label>Quantity</Label>
              <Input type="number" placeholder="0" />
            </FormGroup>
            <FormGroup>
              <Label>Category</Label>
              <Select>
                <option>Select</option>
                <option>Vegetables</option>
                <option>Fruits</option>
                <option>Food</option>
              </Select>
            </FormGroup>
          </FormRow>

          <FormRow>
            <FormGroup>
              <Label>Price</Label>
              <Input type="number" placeholder="0" />
            </FormGroup>
            <FormGroup>
              <Label>Image</Label>
              <FileInput type="file" />
            </FormGroup>
          </FormRow>

          <FormGroup>
            <Label>Description:</Label>
            <TextArea placeholder="Enter product description" />
          </FormGroup>

          <SubmitButton>SUBMIT</SubmitButton>
        </Form>
      </ModalContent>
    </ModalOverlay>
  );
};

export default Add;

// ✅ Styled Components
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 600px;
  text-align: center;
  position: absolute;
  top: 58%;
  left: ${({ isSidebarOpen }) => (isSidebarOpen ? "60%" : "50%")}; /* Moves right */
  transform: translate(-50%, -50%);
  transition: left 0.3s ease-in-out;
`;


const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  float: right;
`;

const ModalTitle = styled.h2`
  text-align: center;
  font-weight: bold;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const FormRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Label = styled.label`
  font-weight: bold;
  text-align: left;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 20px;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 20px;
`;

const FileInput = styled.input`
  padding: 8px;
`;

const TextArea = styled.textarea`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  height: 80px;
`;

const SubmitButton = styled.button`
  margin-top: 15px;
  padding: 12px;
  background: #21551c;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background: #1a4216;
  }
`;
